<template>
  <BaseSelect
    class="jps-round-select jps-small jps-search-sort"
    :options="optionList"
    v-model="sort"
    :value-function="v => v.value"
    :label-function="v => ls(v.name)"
  />
</template>

<script lang="ts" setup>
const { isHina } = useServiceType()
const { ls } = useI18n()

interface Props {
  options?: SortOption[]
  ss: SearchStore<any>
}
const props = withDefaults(defineProps<Props>(), {
  options: () => []
})

const defaultValue = isHina ? 'original' : ''

const optionList = computed(() => {
  return [
    { name: { ja: '適合度順', en: 'Score' }, value: defaultValue },
    ...props.options.map(option => {
      return {
        name: option.name,
        value:
          option.index +
          (option.asccend != null
            ? ':' + (option.asccend ? 'asc' : 'desc')
            : ''),
      }
    }),
  ]
})

const sort = computed({
  get: () => {
    if (props.ss && props.ss.state.sort && props.ss.state.sort.length > 0)
      return props.ss.state.sort[0]
    return defaultValue
  },
  set: v => {
    if (v) {
      props.ss.setSort([v])
    } else {
      props.ss.setSort(null)
    }
  },
})
</script>
